export default __webpack_public_path__ + "static/media/IMG_4914.4c86c42e.png";